import { getI18n } from 'react-i18next';

export const VALIDATION_ZONE_EMPTY_CODE = 'validation.zone.emptyCode';
export const VALIDATION_ZONE_INVALID_CODE_LENGTH = 'validation.zone.invalidCodeLength';
export const VALIDATION_ZONE_INVALID_CODE = 'validation.zone.invalidCode';
export const VALIDATION_ZONE_CODE_ALREADY_IN_USE = 'validation.zone.codeAlreadyInUse';
export const VALIDATION_ZONE_EMPTY_NAME = 'validation.zone.emptyName';
export const VALIDATION_ZONE_INVALID_NAME_LENGTH = 'validation.zone.invalidNameLength';
export const VALIDATION_ZONE_NAME_ALREADY_IN_USE = 'validation.zone.nameAlreadyInUse';
export const VALIDATION_ZONE_INVALID_FLAG_CODE_LENGTH = 'validation.zone.invalidFlagCodeLength';
export const VALIDATION_ZONE_EMPTY_CURRENCY_CODE = 'validation.zone.emptyCurrencyCode';
export const VALIDATION_ZONE_INVALID_CURRENCY_CODE = 'validation.zone.invalidCurrencyCode';
export const VALIDATION_ZONE_EMPTY_CLEARING_HOUSE_CODE = 'validation.zone.emptyClearingHouseCode';
export const VALIDATION_ZONE_INVALID_CLEARING_HOUSE_CODE = 'validation.zone.invalidClearingHouseCode';
export const VALIDATION_ZONE_IMMUTABLE_CODE = 'validation.zone.immutableCode';
export const VALIDATION_ZONE_IMMUTABLE_CURRENCY = 'validation.zone.immutableCurrency';
export const VALIDATION_ZONE_IMMUTABLE_NAME = 'validation.zone.immutableName';
export const VALIDATION_ZONE_IMMUTABLE_FLAG = 'validation.zone.immutableFlag';
export const VALIDATION_ZONE_IMMUTABLE_CLEARING_HOUSE = 'validation.zone.immutableClearingHouse';
export const ERROR_ZONE_NOT_FOUND = 'zone.notFound';
export const ERROR_ZONE_CANNOT_BE_DEACTIVATED = 'zone.noDeactivation';
export const ERROR_ZONE_INVALID_SORT_KEY = 'zone.sort.invalidField';

export const createZoneErrorMessage = (code, params) => { // NOSONAR javascript:S3800
    let result;
    const i18n = getI18n();
    switch (code) {
        case VALIDATION_ZONE_EMPTY_CODE:
            result = i18n.t('zones.error.zone-code-empty');
            break;
        case VALIDATION_ZONE_INVALID_CODE_LENGTH:
            result = i18n.t('zones.error.zone-code-invalid-length', { maxLetters: parseInt(params[0], 10) });
            break;
        case VALIDATION_ZONE_INVALID_CODE:
            result = i18n.t('zones.error.zone-code-invalid');
            break;
        case VALIDATION_ZONE_CODE_ALREADY_IN_USE:
            result = i18n.t('zones.error.zone-code-already-in-use');
            break;
        case VALIDATION_ZONE_EMPTY_NAME:
            result = i18n.t('zones.error.zone-name-empty');
            break;
        case VALIDATION_ZONE_INVALID_NAME_LENGTH:
            result = i18n.t('zones.error.zone-name-invalid-length', { maxLetters: parseInt(params[0], 10) });
            break;
        case VALIDATION_ZONE_NAME_ALREADY_IN_USE:
            result = i18n.t('zones.error.zone-name-already-in-use');
            break;
        case VALIDATION_ZONE_INVALID_FLAG_CODE_LENGTH:
            result = i18n.t('zones.error.zone-flag-code-invalid-length', { maxLetters: parseInt(params[0], 10) });
            break;
        case VALIDATION_ZONE_EMPTY_CURRENCY_CODE:
            result = i18n.t('zones.error.zone-currency-code-empty');
            break;
        case VALIDATION_ZONE_INVALID_CURRENCY_CODE:
            result = i18n.t('zones.error.zone-currency-code-invalid');
            break;
        case VALIDATION_ZONE_EMPTY_CLEARING_HOUSE_CODE:
            result = i18n.t('zones.error.zone-clearing-house-code-empty');
            break;
        case VALIDATION_ZONE_INVALID_CLEARING_HOUSE_CODE:
            result = i18n.t('zones.error.zone-clearing-house-code-invalid');
            break;
        case VALIDATION_ZONE_IMMUTABLE_CODE:
            result = i18n.t('zones.error.zone-immutable-code');
            break;
        case VALIDATION_ZONE_IMMUTABLE_CURRENCY:
            result = i18n.t('zones.error.zone-immutable-currency');
            break;
        case VALIDATION_ZONE_IMMUTABLE_NAME:
            result = i18n.t('zones.error.zone-immutable-name');
            break;
        case VALIDATION_ZONE_IMMUTABLE_FLAG:
            result = i18n.t('zones.error.zone-immutable-flag');
            break;
        case VALIDATION_ZONE_IMMUTABLE_CLEARING_HOUSE:
            result = i18n.t('zones.error.zone-immutable-clearing-house');
            break;
        case ERROR_ZONE_NOT_FOUND:
            result = i18n.t('zones.error.zone-not-found');
            break;
        case ERROR_ZONE_CANNOT_BE_DEACTIVATED:
            result = i18n.t('zones.error.zone-cannot-be-deactivated');
            break;
        case ERROR_ZONE_INVALID_SORT_KEY:
            result = i18n.t('zones.error.zone-invalid-sort-key', { sortKey: params[0] });
            break;
        default:
            result = undefined;
    }
    return result;
};
